(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-cmp-ba-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.cmpbaInit) return;
    slider.dataset.cmpbaInit = '1';
    var media = slider.querySelector('.cmpba__media');
    var range = slider.querySelector('.cmpba__range');
    if (!media || !range) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--pos', pct + '%');
    }
    function posFromEvent(clientX) {
      var rect = media.getBoundingClientRect();
      if (!rect.width) return;
      var pct = ((clientX - rect.left) / rect.width) * 100;
      setPos(pct);
      range.value = Math.round(pct);
    }

    range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

    var dragging = false;
    media.addEventListener('pointerdown', function (e) {
      dragging = true;
      media.setPointerCapture && media.setPointerCapture(e.pointerId);
      posFromEvent(e.clientX);
    });
    media.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      posFromEvent(e.clientX);
    });
    media.addEventListener('pointerup', function () { dragging = false; });
    media.addEventListener('pointercancel', function () { dragging = false; });
  }

  function initAll() {
    document.querySelectorAll('[data-cmpba]').forEach(initSlider);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sp-welcome"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    /* FAQ tabs */
    root.querySelectorAll('.spw-faq-tab').forEach(function(tab){
      tab.addEventListener('click', function(){
        root.querySelectorAll('.spw-faq-tab').forEach(function(t){ t.setAttribute('aria-selected','false'); });
        tab.setAttribute('aria-selected','true');
        root.querySelectorAll('.spw-faq-panel').forEach(function(p){ p.classList.remove('is-active'); });
        var panel = root.querySelector('#' + tab.dataset.panel);
        if (panel) panel.classList.add('is-active');
      });
    });

    /* FAQ accordion */
    root.querySelectorAll('.spw-faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.closest('.spw-faq-item');
        var ans = item.querySelector('.spw-faq-a');
        if (item.classList.contains('is-open')){
          ans.style.maxHeight = null;
          item.classList.remove('is-open');
        } else {
          item.classList.add('is-open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });

    /* reveal on scroll */
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold:0.12, rootMargin:'0px 0px -40px 0px' });
      root.querySelectorAll('.spw-reveal').forEach(function(el){ io.observe(el); });
    } else {
      root.querySelectorAll('.spw-reveal').forEach(function(el){ el.classList.add('in'); });
    }
  }

  function boot(){ document.querySelectorAll('.sp-welcome').forEach(init); }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

  } catch(e) { console.error(e); }
})();
})();
